import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import AcademyApplyForm from "./components/AcademyApplyForm";
const faqs = [
  [
    "Can beginners register interest?",
    "Yes. The planned academy is intended to include foundational learning for people with no prior trading experience. Specific prerequisites will be confirmed with each program.",
  ],
  [
    "When will the academy start?",
    "Dates and enrollment details have not yet been published. Register interest to ask about the planned program and receive relevant follow-up.",
  ],
  [
    "Will there be online and Nairobi sessions?",
    "Both are intended delivery formats. Locations, schedules, equipment requirements, and confirmed formats will be shared before enrollment.",
  ],
  [
    "What will it cost, and how long will it take?",
    "Fees, duration, and weekly time commitments will be confirmed before enrollment. Registering interest does not require payment or commit you to a course.",
  ],
  [
    "Does the academy manage money or guarantee results?",
    "No. The academy is intended for education and market literacy. It does not manage client funds or guarantee trading income. Trading involves risk.",
  ],
];
export default function TradingAcademyPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Trading Academy · In development"
          title="Build knowledge before taking the next step."
        >
          <p>
            A planned learning pathway for Africans and the diaspora, focused on
            financial literacy, market understanding, and disciplined
            decision-making.
          </p>
          <a className="button button-green" href="#apply">
            Register Your Interest <span aria-hidden="true">↗</span>
          </a>
        </PageIntro>
        <section className="section-space">
          <div className="shell purpose-grid">
            <div>
              <p className="eyebrow">Education first</p>
              <h2>A foundation for informed participation.</h2>
              <p className="body-copy">
                The academy is being developed as part of Harambee’s broader
                commitment to education and economic capability. Interest
                registration helps us understand learners’ needs as we shape the
                program.
              </p>
            </div>
            <div className="guide-card">
              <h3>Planned learning themes</h3>
              <ul>
                <li>Financial literacy and understanding market terminology</li>
                <li>How futures markets work and the risks involved</li>
                <li>Simulation-based practice and trading discipline</li>
                <li>Reflecting on decisions and recognizing personal limits</li>
              </ul>
              <p className="body-copy">
                Final curriculum, instructors, dates, fees, and learning formats
                will be confirmed before enrollment.
              </p>
            </div>
          </div>
        </section>
        <section className="section-space bg-[#F8F6F3]">
          <div className="shell">
            <p className="eyebrow">Before you register</p>
            <h2>Your questions, answered.</h2>
            <div className="faq-list">
              {faqs.map(([q, a]) => (
                <details key={q}>
                  <summary>{q}</summary>
                  <p>{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
        <AcademyApplyForm />
      </main>
      <Footer />
    </>
  );
}
